import { useState } from 'react';
import './VenuesPage.css';

function AdminVenuesPage() {
  const [formData, setFormData] = useState({
    name: '',
    city: '',
    address: '',
    capacity: '',
    price: '',
    description: '',
    type: '',
    amenities: '',
    images: '',
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    alert('Venue added successfully!');
    // Reset form
    setFormData({
      name: '',
      city: '',
      address: '',
      capacity: '',
      price: '',
      description: '',
      type: '',
      amenities: '',
      images: '',
    });
  };

  return (
    <div className="admin-venues-page">
      <div className="admin-form-card">
        <h2 className="admin-form-card-title">Add New Venue</h2>
        <form className="admin-data-form" onSubmit={handleSubmit}>
          <div className="admin-form-row">
            <div className="admin-form-group">
              <label htmlFor="name" className="admin-form-label">Venue Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                className="admin-form-input"
                placeholder="Enter venue name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="admin-form-group">
              <label htmlFor="city" className="admin-form-label">City *</label>
              <input
                type="text"
                id="city"
                name="city"
                className="admin-form-input"
                placeholder="Enter city"
                value={formData.city}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="admin-form-group">
            <label htmlFor="address" className="admin-form-label">Address *</label>
            <input
              type="text"
              id="address"
              name="address"
              className="admin-form-input"
              placeholder="Enter full address"
              value={formData.address}
              onChange={handleChange}
              required
            />
          </div>

          <div className="admin-form-row">
            <div className="admin-form-group">
              <label htmlFor="type" className="admin-form-label">Venue Type *</label>
              <select
                id="type"
                name="type"
                className="admin-form-input"
                value={formData.type}
                onChange={handleChange}
                required
              >
                <option value="">Select type</option>
                <option value="banquet-hall">Banquet Hall</option>
                <option value="resort">Resort</option>
                <option value="hotel">Hotel</option>
                <option value="farmhouse">Farmhouse</option>
                <option value="lawn">Lawn</option>
                <option value="beach">Beach Venue</option>
              </select>
            </div>

            <div className="admin-form-group">
              <label htmlFor="capacity" className="admin-form-label">Capacity *</label>
              <input
                type="number"
                id="capacity"
                name="capacity"
                className="admin-form-input"
                placeholder="Enter capacity"
                value={formData.capacity}
                onChange={handleChange}
                required
              />
            </div>

            <div className="admin-form-group">
              <label htmlFor="price" className="admin-form-label">Price Range *</label>
              <input
                type="text"
                id="price"
                name="price"
                className="admin-form-input"
                placeholder="e.g., ₹50,000 - ₹2,00,000"
                value={formData.price}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="admin-form-group">
            <label htmlFor="description" className="admin-form-label">Description *</label>
            <textarea
              id="description"
              name="description"
              className="admin-form-textarea"
              placeholder="Enter venue description"
              rows="4"
              value={formData.description}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <div className="admin-form-group">
            <label htmlFor="amenities" className="admin-form-label">Amenities</label>
            <input
              type="text"
              id="amenities"
              name="amenities"
              className="admin-form-input"
              placeholder="e.g., Parking, AC, Catering, DJ"
              value={formData.amenities}
              onChange={handleChange}
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="images" className="admin-form-label">Image URLs</label>
            <textarea
              id="images"
              name="images"
              className="admin-form-textarea"
              placeholder="Enter image URLs (one per line)"
              rows="3"
              value={formData.images}
              onChange={handleChange}
            ></textarea>
          </div>

          <button type="submit" className="admin-submit-btn">
            Add Venue
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminVenuesPage;
